// ============================================
// ORDER HISTORY SECTION COMPONENT
// ============================================
import { FaDatabase, FaSpinner, FaHistory } from "react-icons/fa"

const OrderHistorySection = ({ selectedUser, loading, orderHistory, pendingOrdersCount }) => {
  const getStatusClass = (status) => {
    const statusMap = {
      Pending: "status-pending",
      Dispatch: "status-dispatch",
      Underloading: "status-underloading",
      Completed: "status-completed",
      Continued: "status-continued",
      Cancelled: "status-cancelled",
      Paused: "status-paused",
    }
    return statusMap[status] || ""
  }

  return (
    <div className="order-history-tab">
      <div className="section-header">
        <FaHistory className="section-icon" />
        <h2>Order History</h2>
      </div>
      <p className="section-subtitle">Order history for {selectedUser.username || selectedUser.email}</p>

      <div className="order-stats">
        <div className="stat-card pending">
          <span className="stat-label">Pending Orders</span>
          <span className="stat-value">{pendingOrdersCount}</span>
        </div>
        <div className="stat-card total">
          <span className="stat-label">Total Orders</span>
          <span className="stat-value">{orderHistory.length}</span>
        </div>
      </div>

      {loading ? (
        <div className="loading-state">
          <FaSpinner className="spinner" /> Loading order history...
        </div>
      ) : orderHistory.length === 0 ? (
        <div className="empty-state">
          <FaDatabase className="empty-icon" />
          <p>No orders found for this user.</p>
        </div>
      ) : (
        <div className="order-table-wrapper">
          <table className="order-table">
            <thead>
              <tr>
                <th>Code ID</th>
                <th>Date</th>
                <th>Brand</th>
                <th>Quantity</th>
                <th>Site Address</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {orderHistory.map((order) => (
                <tr key={order.id}>
                  <td>
                    <span className="code-badge">{order.code}</span>
                  </td>
                  <td>
                    {order.timestamp
                      ? new Date(order.timestamp).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : "N/A"}
                  </td>
                  <td>{order.brand || "N/A"}</td>
                  <td>{order.quantity || "N/A"}</td>
                  <td className="address-cell">
                    {order.siteAddress?.address
                      ? `${order.siteAddress.address}, ${order.siteAddress.state}${
                          order.siteAddress.pincode ? `, ${order.siteAddress.pincode}` : ""
                        }`
                      : "N/A"}
                  </td>
                  <td>
                    <span className={`order-status ${getStatusClass(order.status)}`}>
                      {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default OrderHistorySection
